/**
 * Test IDs for Serpix UI. Kebab-case, function-descriptive.
 */
export const TEST_IDS = {
  // Landing
  landingLoginBtn: "landing-login-btn",
  landingRegisterBtn: "landing-register-btn",
  langSwitch: "lang-switch",

  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error-msg",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerTenantName: "register-tenant-name-input",
  registerTimezone: "register-timezone-select",
  registerSubmit: "register-submit-btn",
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-btn",
  logoutBtn: "logout-btn",

  // Layout
  sidebarDashboard: "sidebar-dashboard-link",
  sidebarProjects: "sidebar-projects-link",
  sidebarUsers: "sidebar-users-link",
  sidebarSettings: "sidebar-settings-link",
  sidebarBilling: "sidebar-billing-link",
  sidebarEmailOutbox: "sidebar-email-outbox-link",
  sidebarPlatform: "sidebar-platform-link",
  onlyMineToggle: "only-mine-toggle",
  topbarUserMenu: "topbar-user-menu",

  // Projects
  newProjectBtn: "new-project-btn",
  projectNameInput: "project-name-input",
  projectDescInput: "project-description-input",
  projectSaveBtn: "project-save-btn",
  projectCard: (id) => `project-card-${id}`,

  // Lists / tasks
  newListBtn: "new-list-btn",
  listNameInput: "list-name-input",
  listSaveBtn: "list-save-btn",
  quickAddTaskInput: (listId) => `quick-add-task-input-${listId}`,
  taskRow: (id) => `task-row-${id}`,
  taskTitle: (id) => `task-title-${id}`,
  taskCheckbox: (id) => `task-checkbox-${id}`,
  taskDeleteBtn: (id) => `task-delete-btn-${id}`,
  taskDialogTitle: "task-dialog-title-input",
  taskDialogSave: "task-dialog-save-btn",
  taskDialogClose: "task-dialog-close-btn",
  taskTabs: "task-tabs",
  taskTabDetails: "task-tab-details",
  taskTabSubtasks: "task-tab-subtasks",
  taskTabComments: "task-tab-comments",
  taskTabActivity: "task-tab-activity",
  taskTabFiles: "task-tab-files",
  taskRecurrenceSelect: "task-recurrence-select",
  subtaskAddInput: "subtask-add-input",
  subtaskAddBtn: "subtask-add-btn",
  subtaskRow: (id) => `subtask-row-${id}`,
  subtaskCheckbox: (id) => `subtask-checkbox-${id}`,
  subtaskDragHandle: (id) => `subtask-drag-${id}`,
  commentInput: "comment-input",
  commentSubmitBtn: "comment-submit-btn",
  commentMarkdownHint: "comment-markdown-hint",

  // Attachments
  attachmentInput: "attachment-file-input",
  attachmentUploadBtn: "attachment-upload-btn",
  attachmentRow: (id) => `attachment-row-${id}`,
  attachmentDownloadBtn: (id) => `attachment-download-btn-${id}`,
  attachmentDeleteBtn: (id) => `attachment-delete-btn-${id}`,

  // Onboarding wizard
  onboardingDialog: "onboarding-dialog",
  onboardingProjectName: "onboarding-project-name",
  onboardingInvites: "onboarding-invites-input",
  onboardingFirstTask: "onboarding-first-task",
  onboardingNext: "onboarding-next-btn",
  onboardingFinish: "onboarding-finish-btn",
  onboardingSkip: "onboarding-skip-btn",

  // Auth pages
  resetTokenInput: "reset-token-input",
  resetPasswordInput: "reset-password-input",
  resetConfirmInput: "reset-confirm-input",
  resetSubmitBtn: "reset-submit-btn",
  acceptInviteToken: "accept-invite-token-input",
  acceptInvitePassword: "accept-invite-password-input",
  acceptInviteSubmit: "accept-invite-submit-btn",
  verifyBanner: "verify-email-banner",
  verifyResendBtn: "verify-email-resend-btn",

  // Notification prefs
  notifRow: (key) => `notif-row-${key}`,
  notifToggle: (key) => `notif-toggle-${key}`,
  sidebarNotifPrefs: "sidebar-notif-prefs-link",

  // Reassign
  sidebarReassign: "sidebar-reassign-link",
  reassignSelectAll: "reassign-select-all",
  reassignPickUser: "reassign-pick-user-select",
  reassignSubmit: "reassign-submit-btn",
  reassignRow: (id) => `reassign-row-${id}`,
  reassignRowCheckbox: (id) => `reassign-row-checkbox-${id}`,

  // Users
  inviteUserBtn: "invite-user-btn",
  inviteEmail: "invite-email-input",
  inviteName: "invite-name-input",
  inviteRole: "invite-role-select",
  inviteSubmit: "invite-submit-btn",
  userRow: (id) => `user-row-${id}`,
  toggleUserActive: (id) => `user-active-toggle-${id}`,
  transferSuperAdmin: (id) => `user-transfer-sa-${id}`,

  // Settings
  tenantNameInput: "tenant-name-input",
  tenantTimezoneSelect: "tenant-timezone-select",
  tenantSaveBtn: "tenant-save-btn",

  // Billing
  billingBanner: "billing-banner",
  billingCardInput: "billing-card-input",
  billingSubscribeBtn: "billing-subscribe-btn",

  // Platform
  platformTenantRow: (id) => `platform-tenant-row-${id}`,
  platformExtendTrial: (id) => `platform-extend-trial-${id}`,
  platformSetStatus: (id) => `platform-set-status-${id}`,

  // Dashboard
  dashboardTotalTasks: "dashboard-total-tasks",
  dashboardOpenTasks: "dashboard-open-tasks",
  dashboardOverdue: "dashboard-overdue",
  dashboardCsvExport: "dashboard-csv-export",
  // Reactions
  reactionChip: (cid, e) => `reaction-chip-${cid}-${e}`,
  reactionAddBtn: (cid) => `reaction-add-btn-${cid}`,
  reactionPick: (cid, e) => `reaction-pick-${cid}-${e}`,
  typingIndicator: "typing-indicator",

  // Command palette
  cmdKButton: "cmd-k-button",
  commandPalette: "command-palette",
  commandPaletteInput: "command-palette-input",
  cmdItemTask: (id) => `cmd-item-task-${id}`,
  cmdItemProject: (id) => `cmd-item-project-${id}`,

  // DND
  dndToggle: "dnd-toggle",
  dndOption: (m) => `dnd-option-${m}`,
  dndClear: "dnd-clear",

  // Integrations
  sidebarIntegrations: "sidebar-integrations-link",
  integrationSlackInput: "integration-slack-input",
  integrationSlackTest: "integration-slack-test-btn",
  integrationDiscordInput: "integration-discord-input",
  integrationDiscordTest: "integration-discord-test-btn",
  integrationEventToggle: (k) => `integration-event-toggle-${k}`,
  integrationSaveBtn: "integration-save-btn",

  // Unread indicator
  taskUnreadDot: (id) => `task-unread-dot-${id}`,

  // List view enhancements
  listSortMenu: "list-sort-menu-btn",
  listSortOption: (k) => `list-sort-option-${k}`,
  listGroupToggle: "list-group-toggle-btn",
  listGroupOption: (k) => `list-group-option-${k}`,
  listShowCompleted: "list-show-completed-toggle",
  listGroupHeader: (k) => `list-group-header-${k}`,
  listAddTaskBtn: "list-add-task-btn",
  listAddTaskInput: "list-add-task-composer-input",
  listAddTaskListSelect: "list-add-task-list-select",
  listAddTaskSubmit: "list-add-task-composer-submit",

  // Task row quick actions (hover)
  taskRowDateBtn: (id) => `task-row-date-btn-${id}`,
  taskRowDateInput: (id) => `task-row-date-input-${id}`,
  taskRowDateClear: (id) => `task-row-date-clear-${id}`,

  // Right panel
  taskPanel: "task-right-panel",
  taskPanelClose: "task-right-panel-close",
  taskPanelExpand: "task-right-panel-expand",
  taskPanelTitle: "task-right-panel-title-input",
  taskPanelSave: "task-right-panel-save",
  taskPanelDelete: "task-right-panel-delete",
  taskPanelTabDetails: "task-panel-tab-details",
  taskPanelTabSubtasks: "task-panel-tab-subtasks",
  taskPanelTabComments: "task-panel-tab-comments",
  taskPanelTabFiles: "task-panel-tab-files",
  taskPanelTabActivity: "task-panel-tab-activity",

  // Undo toast
  undoTaskComplete: "undo-task-complete-btn",
};
